<template>
  <div class="auth">
    <div class="wrapper">
      <div class="auth__in">
        <div class="signup">
          <div class="auth-heading">
            <h2>{{ trans.text.register.registration }}</h2>
            <p>{{ trans.text.register.alreadyHave }}
              <a :href="'/'+ lang +'/login'">{{ trans.text.register.logIn }}</a>
            </p>
          </div>

          <div class="auth-form">
            <div class="inp-group">
              <label v-if="!getEmailError" for="signup-mail">{{ trans.text.register.email }}</label>
              <span v-if="getEmailError" class="inp-error__text_">{{ getEmailError }}</span>
              <input id="signup-mail" v-model="email" class="inp-style inp-fw" name="email" type="email">
            </div>

            <div class="inp-group">
              <label v-if="!getNameError" for="signup-name">{{ trans.text.register.name }}</label>
              <span v-if="getNameError" class="inp-error__text_">{{ getNameError }}</span>
              <input id="signup-name" v-model="f_name" class="inp-style inp-fw" name="name" type="text">
            </div>

            <div class="inp-group">
              <label v-if="!showPasswordError" for="signup-pwd">{{ trans.text.register.password }}</label>
              <span v-if="showPasswordError" class="inp-error__text_">{{ getPasswordErrorText }}</span>
              <input id="signup-pwd" v-model="password" class="inp-style inp-fw" name="password"
                     type="password">
            </div>

            <div class="inp-group">
              <label v-if="!showPasswordConfirmationError"
                     for="signup-pwd2">{{ trans.text.register.retypePassword }}</label>
              <span v-if="showPasswordConfirmationError"
                    class="inp-error__text_">{{ trans.text.register.notSame }}</span>
              <input id="signup-pwd2" v-model="password_confirmation" class="inp-style inp-fw" name="password"
                     type="password">
            </div>

            <div class="inp-group">
              <input id="test" v-model="ad_mailings" class="inp-group__checkbox" type="checkbox">
              <label for="test">
                <span class="checkbox"></span>
                <span class="text-black">{{ trans.text.register.getUpdates }}</span>
              </label>
            </div>

            <div class="btn__wrapper-social">
              <button
                :class="{'is-disabled':registerDisabled,'btn-green':!registerDisabled,'btn-gray':registerDisabled}"
                class="btn  btn-submit size btn-sm" @click="submit">
                {{ trans.text.register.continue }}
              </button>
              <a v-if="false" class="btn-apple" href="/api/auth/apple/login?register=true"></a>
              <facebook-login
                v-if="!fb_token"
                :ref="'fbBtn'"
                appId="560487734518765"
                class="btn btn-fb btn-sm"
                loginLabel=""
                logoutLabel=""
                @login="onLogin"
                @logout="onLogout"
                @get-initial-status="getUserData"
                @sdk-loaded="sdkLoaded">
              </facebook-login>
            </div>
            <p class="text">{{ trans.text.register.accepting }}
              <a :href="`/${lang}/page/legal-note`" target="_blank">{{ trans.text.register.policy }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import facebookLogin from 'facebook-login-vuejs';

export default {
  props: ['lang', 'trans'],
  components: {facebookLogin},
  data() {
    return {
      email: '',
      f_name: '',
      password: '',
      password_confirmation: '',
      ad_mailings: false,
      wrongFormatPassword: false,
      wrongPasswordConfirmation: false,
      fb_token: null,
      isConnected: false,
      FB: undefined,
    }
  },
  computed: {
    ...mapGetters(['getEmailError', 'getNameError', 'getPasswordError']),
    showPasswordError() {
      return !!this.getPasswordError || this.wrongFormatPassword;
    },
    showPasswordConfirmationError() {
      return this.wrongPasswordConfirmation;
    },
    getPasswordErrorText() {
      if (this.getPasswordError) {
        return this.getPasswordError;
      }
      return this.trans.text.register.passwordValidation
    },
    registerDisabled() {
      return this.email.length === 0
        || this.f_name.length === 0
        || this.password.length === 0
        || this.password_confirmation.length === 0
        || this.wrongFormatPassword
        || this.wrongPasswordConfirmation
    }
  },
  methods: {
    ...mapActions(['Register', 'Login', 'LoginByFaceBook']),
    getUserData() {
      if (this.FB) {
        this.FB.api('/me', 'GET', {fields: 'id,name,email'},
          userInformation => {
            this.personalID = userInformation.id;
            this.email = userInformation.email;
            this.name = userInformation.name;
          }
        )
      }
    },
    onLogin(event) {
      if (!!event.response.authResponse) {
        this.isConnected = true;
        this.fb_token = event.response.authResponse.accessToken;
        this.getUserData();
        this.login();
      }
    },
    login() {
      this.LoginByFaceBook({
        fb_token: this.fb_token,
        path: this.$path,
        lang: this.lang,
        register: true
      })
    },
    onLogout(event) {
      this.isConnected = false;
    },
    sdkLoaded(payload) {
      this.isConnected = payload.isConnected;
      this.FB = payload.FB;
      if (this.isConnected) this.getUserData()
    },
    submit() {
      if (this.registerDisabled) {
        if (!this.email.length) {
          this.$store.commit('updateEmailError', this.trans.text.register.emailRequired);
        }
        if (!this.f_name.length) {
          this.$store.commit('updateNameError', this.trans.text.register.nameRequired);
        }
        if (!this.password.length) {
          this.wrongFormatPassword = true;
        }
        if (!this.password_confirmation.length) {
          this.wrongPasswordConfirmation = true;
        }
        let ctx = this;
        setTimeout(function () {
          ctx.$store.commit('updateEmailError', '');
          ctx.$store.commit('updateNameError', '');
          ctx.wrongFormatPassword = false;
          ctx.wrongPasswordConfirmation = false;
        }.bind(ctx), 5000)
        return false;
      }
      this.Register({
        email: this.email,
        f_name: this.f_name,
        password: this.password,
        ad_mailings: this.ad_mailings,
        password_confirmation: this.password_confirmation,
        path: this.$path,
        currentLang: this.lang
      })
    }
  },
  watch: {
    password: {
      handler: function (password) {
        this.$store.commit('updatePasswordError', '');
        if (password.length === 0) {
          this.wrongFormatPassword = false;
        } else {
          this.wrongFormatPassword = password.trim().length < 8;
        }
      }
    },
    password_confirmation: {
      handler: function (password) {
        if (password.length === 0) {
          this.wrongPasswordConfirmation = false;
        } else {
          this.wrongPasswordConfirmation = password !== this.password;
        }
      }
    },
    email: {
      handler: function (email) {
        this.$store.commit('updateEmailError', '');
      }
    },
    f_name: {
      handler: function (email) {
        this.$store.commit('updateNameError', '');
      }
    }
  }
}
</script>

<style scoped>
.btn-submit.disabled {
  /*background: #c9c9c9;*/
  background: #efefef;
  color: rgba(0, 0, 0, .5);
  cursor: default;
}

.size {
  /*TODO: Change this value to calc(100% - 130px when enable apple auth )*/
  /*TODO: Change this value to calc(100% - 60px when disable apple auth )*/
  min-width: calc(100% - 60px) !important;
}
</style>
